// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.blog-page-wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
}

.blog-page-main {
  flex: 1 1;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
}

.title-wrap {
  margin-bottom: 30px;
  text-align: left;
}

.title-wrap .text {
  font-size: 18px;
  color: #666;
}

.blog-container {
  width: 100%;
}

.blog-form {
  background-color: #f8f9fa;
  border-radius: 8px;
  padding: 30px;
  margin-bottom: 40px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.blog-form input,
.blog-form textarea {
  width: 100%;
  margin-bottom: 20px;
  padding: 12px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 16px;
}

.blog-form textarea {
  min-height: 150px;
  resize: vertical;
}

.blog-form button {
  padding: 12px 24px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  transition: background-color 0.3s ease;
}

.blog-form button:hover {
  background-color: #0056b3;
}

.blog-form .quill {
  margin-bottom: 20px;
}

.blog-form .ql-container {
  min-height: 200px;
}

.blog-posts {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.blog-post {
  background-color: #ffffff;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 25px;
  transition: box-shadow 0.3s ease;
  position: relative;
}

.blog-post:hover {
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.blog-post h2 {
  font-size: 24px;
  color: #333;
  margin-bottom: 10px;
}

.post-meta {
  font-size: 14px;
  color: #6c757d;
  margin-bottom: 15px;
}

.blog-post p {
  font-size: 16px;
  color: #555;
  line-height: 1.6;
}

.delete-btn {
  position: absolute;
  top: 15px;
  right: 15px;
  background-color: #dc3545;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 5px 10px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.3s ease;
}

.delete-btn:hover {
  background-color: #c82333;
}

.blog-post .ql-editor {
  padding: 0;
}

.blog-post .ql-editor p {
  margin-bottom: 1em;
}

@media (max-width: 768px) {
  .blog-page-main {
    padding: 20px;
  }
}

/* Add this to ensure the Banner component spans 100% */
.blog-page-wrapper > div:first-child {
  width: 100%;
}

.admin-controls {
  position: absolute;
  top: 15px;
  right: 15px;
  display: flex;
  gap: 10px;
}

.edit-btn,
.delete-btn {
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 5px 10px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.3s ease;
}

.edit-btn:hover {
  background-color: #0056b3;
}

.delete-btn {
  background-color: #dc3545;
}

.delete-btn:hover {
  background-color: #c82333;
}

.cancel-btn {
  margin-left: 10px;
  background-color: #6c757d;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 12px 24px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  transition: background-color 0.3s ease;
}

.cancel-btn:hover {
  background-color: #5a6268;
}

.delete-btn {
  position: static;
  top: auto;
  right: auto;
}`, "",{"version":3,"sources":["webpack://./src/pages/Blog/Blog.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,SAAO;EACP,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;;EAEE,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA,uDAAuD;AACvD;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,WAAW;AACb","sourcesContent":[".blog-page-wrapper {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  width: 100%;\n}\n\n.blog-page-main {\n  flex: 1;\n  width: 100%;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 40px 20px;\n}\n\n.title-wrap {\n  margin-bottom: 30px;\n  text-align: left;\n}\n\n.title-wrap .text {\n  font-size: 18px;\n  color: #666;\n}\n\n.blog-container {\n  width: 100%;\n}\n\n.blog-form {\n  background-color: #f8f9fa;\n  border-radius: 8px;\n  padding: 30px;\n  margin-bottom: 40px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n}\n\n.blog-form input,\n.blog-form textarea {\n  width: 100%;\n  margin-bottom: 20px;\n  padding: 12px;\n  border: 1px solid #ced4da;\n  border-radius: 4px;\n  font-size: 16px;\n}\n\n.blog-form textarea {\n  min-height: 150px;\n  resize: vertical;\n}\n\n.blog-form button {\n  padding: 12px 24px;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: 600;\n  transition: background-color 0.3s ease;\n}\n\n.blog-form button:hover {\n  background-color: #0056b3;\n}\n\n.blog-form .quill {\n  margin-bottom: 20px;\n}\n\n.blog-form .ql-container {\n  min-height: 200px;\n}\n\n.blog-posts {\n  display: flex;\n  flex-direction: column;\n  gap: 30px;\n}\n\n.blog-post {\n  background-color: #ffffff;\n  border: 1px solid #e9ecef;\n  border-radius: 8px;\n  padding: 25px;\n  transition: box-shadow 0.3s ease;\n  position: relative;\n}\n\n.blog-post:hover {\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);\n}\n\n.blog-post h2 {\n  font-size: 24px;\n  color: #333;\n  margin-bottom: 10px;\n}\n\n.post-meta {\n  font-size: 14px;\n  color: #6c757d;\n  margin-bottom: 15px;\n}\n\n.blog-post p {\n  font-size: 16px;\n  color: #555;\n  line-height: 1.6;\n}\n\n.delete-btn {\n  position: absolute;\n  top: 15px;\n  right: 15px;\n  background-color: #dc3545;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  padding: 5px 10px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: background-color 0.3s ease;\n}\n\n.delete-btn:hover {\n  background-color: #c82333;\n}\n\n.blog-post .ql-editor {\n  padding: 0;\n}\n\n.blog-post .ql-editor p {\n  margin-bottom: 1em;\n}\n\n@media (max-width: 768px) {\n  .blog-page-main {\n    padding: 20px;\n  }\n}\n\n/* Add this to ensure the Banner component spans 100% */\n.blog-page-wrapper > div:first-child {\n  width: 100%;\n}\n\n.admin-controls {\n  position: absolute;\n  top: 15px;\n  right: 15px;\n  display: flex;\n  gap: 10px;\n}\n\n.edit-btn,\n.delete-btn {\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  padding: 5px 10px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: background-color 0.3s ease;\n}\n\n.edit-btn:hover {\n  background-color: #0056b3;\n}\n\n.delete-btn {\n  background-color: #dc3545;\n}\n\n.delete-btn:hover {\n  background-color: #c82333;\n}\n\n.cancel-btn {\n  margin-left: 10px;\n  background-color: #6c757d;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  padding: 12px 24px;\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: 600;\n  transition: background-color 0.3s ease;\n}\n\n.cancel-btn:hover {\n  background-color: #5a6268;\n}\n\n.delete-btn {\n  position: static;\n  top: auto;\n  right: auto;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
